import * as React from 'react';
const OtherServicesIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={90}
    height={90}
    fill="none"
    viewBox="0 0 96 96"
    {...props}
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H92C94.2091 0 96 1.79086 96 4V92C96 94.2091 94.2091 96 92 96H4C1.79086 96 0 94.2091 0 92V4Z"
      fill="url(#OtherServicesIcon_svg)"
    />
    <path
      d="M72 32H60V30C60 28.4087 59.3679 26.8826 58.2426 25.7574C57.1174 24.6321 55.5913 24 54 24H42C40.4087 24 38.8826 24.6321 37.7574 25.7574C36.6321 26.8826 36 28.4087 36 30V32H24C22.9391 32 21.9217 32.4214 21.1716 33.1716C20.4214 33.9217 20 34.9391 20 36V64C20 65.0609 20.4214 66.0783 21.1716 66.8284C21.9217 67.5786 22.9391 68 24 68H72C73.0609 68 74.0783 67.5786 74.8284 66.8284C75.5786 66.0783 76 65.0609 76 64V36C76 34.9391 75.5786 33.9217 74.8284 33.1716C74.0783 32.4214 73.0609 32 72 32ZM40 30C40 29.4696 40.2107 28.9609 40.5858 28.5858C40.9609 28.2107 41.4696 28 42 28H54C54.5304 28 55.0391 28.2107 55.4142 28.5858C55.7893 28.9609 56 29.4696 56 30V32H40V30ZM72 36V44H64V42C64 41.4696 63.7893 40.9609 63.4142 40.5858C63.0391 40.2107 62.5304 40 62 40C61.4696 40 60.9609 40.2107 60.5858 40.5858C60.2107 40.9609 60 41.4696 60 42V44H36V42C36 41.4696 35.7893 40.9609 35.4142 40.5858C35.0391 40.2107 34.5304 40 34 40C33.4696 40 32.9609 40.2107 32.5858 40.5858C32.2107 40.9609 32 41.4696 32 42V44H24V36H72ZM72 64H24V48H32V50C32 50.5304 32.2107 51.0391 32.5858 51.4142C32.9609 51.7893 33.4696 52 34 52C34.5304 52 35.0391 51.7893 35.4142 51.4142C35.7893 51.0391 36 50.5304 36 50V48H60V50C60 50.5304 60.2107 51.0391 60.5858 51.4142C60.9609 51.7893 61.4696 52 62 52C62.5304 52 63.0391 51.7893 63.4142 51.4142C63.7893 51.0391 64 50.5304 64 50V48H72V64Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="OtherServicesIcon_svg"
        x1="48"
        y1="0"
        x2="48"
        y2="96"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#17B1D6" />
        <stop offset="1" stopColor="#8576FF" />
      </linearGradient>
    </defs>
  </svg>
);
export default OtherServicesIcon;
